import { CaptchaSendType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { appI18n } from '@flowus/common/i18n';

import { useLogin } from '../../../hook/use-login';
import { useVerifySmsCode } from '../../../hook/use-verify-code';
import { Button } from '../../../uikit/web/button';
import { CaptchaComp } from '../../../uikit/web/captcha';
import { Input } from '../../../uikit/web/input';
import { Regex } from '../../../utils';

interface VerifyPhoneCodeProps {
  phone: string;
  onSuccess: (authorizationCode: string) => void;
}
export const VerifyPhoneCode: FC<VerifyPhoneCodeProps> = (props) => {
  const { phone, onSuccess } = props;
  const verifySmsCode = useVerifySmsCode();
  const { sendVerifyCode, verifyCode, setVerifyCode, verifyCodeError, setVerifyCodeError } =
    useLogin({ account: phone });

  const tryVerifySmsCode = async () => {
    if (!Regex.VerifyCode.test(verifyCode)) {
      setVerifyCodeError(appI18n.t('pkg_login.verify_code_error') as string);
      return;
    }

    const res = await verifySmsCode({
      account: phone,
      code: verifyCode,
      type: CaptchaSendType.CHANGE_BIND,
      onError: setVerifyCodeError,
    });

    if (res?.authorizationCode) {
      onSuccess(res.authorizationCode);
    }
  };

  return (
    <div className="next-modal pt-10 pb-5 px-7 flex flex-col items-center min-w-[400px]">
      <div className="mb-5 text-t1-medium">{appI18n.t('pkg_login.verify_phone')}</div>
      <div className="mb-5 text-t2">
        {appI18n.t('pkg_login.verify_code_sent_to_phone', { phone })}
      </div>
      <Input
        value={verifyCode}
        maxLength={6}
        type="number"
        className="mb-10 w-full"
        placeholder={appI18n.t('pkg_login.input_verify_code_placeholder') as string}
        inputClassName="px-3 h-8 text-t2"
        onEnter={() => void tryVerifySmsCode()}
        warning={verifyCodeError}
        onChange={(v) => setVerifyCode(v.toString())}
        addonAfter={
          <CaptchaComp
            autoClick
            className="mr-3"
            showIcon={false}
            onSendVerifyCode={() => {
              return sendVerifyCode(CaptchaSendType.LOGIN);
            }}
          />
        }
      />
      <Button className="text-t2 h-8" size="auto" onClick={() => void tryVerifySmsCode()}>
        {appI18n.t('pkg_login.next_step')}
      </Button>
    </div>
  );
};
